import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getBackendUrl } from '../config/api';

const SiteBrandingContext = createContext();

export const useSiteBranding = () => {
  const context = useContext(SiteBrandingContext);
  if (!context) {
    throw new Error('useSiteBranding must be used within a SiteBrandingProvider');
  }
  return context;
};

export const SiteBrandingProvider = ({ children }) => {
  const [siteBranding, setSiteBranding] = useState({
    site_name: "PM SHRI GGSSS FARMANA (44337)",
    site_tagline: "Excellence in Education",
    logo_url: null,
    primary_color: "#2563eb",
    secondary_color: "#7c3aed"
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSiteBranding = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const BACKEND_URL = getBackendUrl();
      const response = await fetch(`${BACKEND_URL}/api/site/branding`);
      
      if (response.ok) {
        const data = await response.json();
        setSiteBranding(data);
      } else {
        throw new Error('Failed to fetch site branding');
      }
    } catch (error) {
      console.error('Error fetching site branding:', error);
      setError(error.message);
      // Keep default values if fetch fails
    } finally {
      setLoading(false);
    }
  }, []);

  // Refresh function that can be called to update branding
  const refreshSiteBranding = useCallback(() => {
    fetchSiteBranding();
  }, [fetchSiteBranding]);

  // Initial fetch on mount
  useEffect(() => {
    fetchSiteBranding();
  }, [fetchSiteBranding]);

  const value = {
    siteBranding,
    loading,
    error,
    refreshSiteBranding
  };

  return (
    <SiteBrandingContext.Provider value={value}>
      {children}
    </SiteBrandingContext.Provider>
  );
};

export default SiteBrandingContext;